import "./index.css";

export const CuponesPreimpresos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Administrar cupones preimpresos</h1>
      </div>
    </div>
  );
};
